import { useQuery, gql } from '@apollo/client';

const GET_USER_INSPECTIONS = gql`
   query GetUserInspections {
      getUserInspections {
         id
         permitId
         applicationNumber
         applicationType
         scheduledDate
         scheduledTime
         location
         inspectionStatus
         history {
            action
            timestamp
            notes
         }
         createdAt
         updatedAt
      }
   }
`;

export const useInspections = () => {
   const { data, loading, error, refetch } = useQuery(GET_USER_INSPECTIONS);

   return {
      inspections: data?.getUserInspections || [],
      loading,
      error,
      refetch
   };
};